import { formatDate } from '@/@core/utils/utils'
import { judgeStrength } from '@/views/analyze/ACMG'
import { getACMG } from '@/views/analyze/ACMG/ACMGClassification'
import { classify } from '@/views/analyze/ACMG/ACMGClassificationNew'
import { ACMG_evidences_en } from '../CurrentRepoet'

export const getTemplate12 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  thalassemia: any,
  samples: any[],
  userAcmgData: any[],
  affected_child_clinicalInformation: any,
  t: any
) => {
  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-color',
      children: [
        {
          text: 'Single-gene disease carrier screening report'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'Basic information：'
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Name`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [{ text: `${reportValue.patient?.patientName ?? '-'}` }]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Gender`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${(reportValue?.patient?.gender as string) ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Age`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${
                reportValue.patient?.dateOfBirth
                  ? (Math.floor(
                      (new Date().valueOf() -
                        new Date(reportValue.patient?.dateOfBirth).valueOf()) /
                        3.15576e10
                    ) <= 0
                      ? 0
                      : Math.floor(
                          (new Date().valueOf() -
                            new Date(
                              reportValue.patient?.dateOfBirth
                            ).valueOf()) /
                            3.15576e10
                        )) + 'years old'
                  : '-'
              }`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Sample Number`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${reportValue.sample?.id ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Sample type`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Contact information`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${reportValue?.patient?.phone ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Inspection unit`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${reportValue?.patient?.infirmaryName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Department`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${reportValue?.patient?.departmentName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Deliver date`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-13',
          children: [
            {
              text: `${formatDate(report?.createdAt, 'YYYY/MM/DD/HH') ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Analyze the project`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-80',
          children: [
            {
              text: `-`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Gestational weeks`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-80',
          children: [
            {
              text: `-`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Medical history`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-80',
          children: [
            {
              text: `-`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed-20',
          children: [
            {
              text: `Detection method`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-80',
          children: [
            {
              text: `NGS`
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'The result suggests： '
        },
        {
          type: 'radio-group-eh',
          children: [
            {
              text: '结果提示： □疾病高风险 □疾病中风险 □携带者  □阴性'
            }
          ]
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: "If high-risk genetic variation loci are found to be carried within the testing range, please seek genetic counseling in combination with the test results of the person's spouse, family history, etc."
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'Screening and analysis results of hotspots for thalassemia:'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: 'Disease type' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Mutant gene' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Nucleotide changes' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Chromosome position' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Result' }]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'α thalassemia'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'HBA1'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'HBA2'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `${
                        thalassemia &&
                        thalassemia.HBA1x &&
                        thalassemia.HBA1x.length &&
                        thalassemia.HBA1x[0].includes('//')
                          ? thalassemia.HBA1x[0].split('//')[0]
                          : '-'
                      }/${
                        thalassemia &&
                        thalassemia.HBA1y &&
                        thalassemia.HBA1y.length &&
                        thalassemia.HBA1y[0].includes('//')
                          ? thalassemia.HBA1y[0].split('//')[0]
                          : '-'
                      }`
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `${
                        thalassemia &&
                        thalassemia.HBA2x &&
                        thalassemia.HBA2x.length &&
                        thalassemia.HBA2x[0].includes('//')
                          ? thalassemia.HBA2x[0].split('//')[0]
                          : '-'
                      }/${
                        thalassemia &&
                        thalassemia.HBA2y &&
                        thalassemia.HBA2y.length &&
                        thalassemia.HBA2y[0].includes('//')
                          ? thalassemia.HBA2y[0].split('//')[0]
                          : '-'
                      }`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `${
                        thalassemia &&
                        thalassemia.HBA1x &&
                        thalassemia.HBA1x.length &&
                        thalassemia.HBA1x[0].includes('//')
                          ? thalassemia.HBA1x[0].split('//')[1]
                          : '-'
                      }/${
                        thalassemia &&
                        thalassemia.HBA1y &&
                        thalassemia.HBA1y.length &&
                        thalassemia.HBA1y[0].includes('//')
                          ? thalassemia.HBA1y[0].split('//')[1]
                          : '-'
                      }`
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `${
                        thalassemia &&
                        thalassemia.HBA2x &&
                        thalassemia.HBA2x.length &&
                        thalassemia.HBA2x[0].includes('//')
                          ? thalassemia.HBA2x[0].split('//')[1]
                          : '-'
                      }/${
                        thalassemia &&
                        thalassemia.HBA2y &&
                        thalassemia.HBA2y.length &&
                        thalassemia.HBA2y[0].includes('//')
                          ? thalassemia.HBA2y[0].split('//')[1]
                          : '-'
                      }`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'radio-group-α-thalassemia-eh',
                  children: [
                    {
                      text: '-'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'β thalassemia'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'HBB'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '-'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: '-'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'radio-group-β-thalassemia-eh',
                  children: [
                    {
                      text: '-'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: 'Note: 1. "-" indicates that no pathogenic loci carrying the gene were found in the tested individual within the range of the positive loci screened.'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '          2. -- SEA, -- THA1, -- FIL, etc. indicate the deletion of two α genes; -α3.7 and -α4.2 indicate the deletion of one α gene.'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '          3. The above conclusions are all laboratory test data and are only used for the purpose of mutation detection for clinical reference. They do not represent the final clinical diagnosis results. Clinical genetic counseling for thalassemia: Individuals carrying quiescent alpha-thalassemia, individuals carrying alpha-standard thalassemia (characteristics of alpha-thalassemia), and individuals carrying β -thalassemia, who are not affected by the disease, usually have no clinical anemia symptoms (hematological screening may show the characteristics of microcytic hypochromic anemia) and remain stable throughout life, have no impact on development, and do not require targeted treatment (no clinical management is needed). In addition, alpha-globin gene duplication (including triplets, quadruplets and even polyplets) usually does not have clinical anemia symptoms either; However, when combined with β -thalassemia, the clinical manifestations vary greatly, ranging from mild anemia to severe anemia. Other types (HBH disease, HbBats fetal edema syndrome, homozygous or double heterozygous mutation carriers of β -thalassemia) are affected individuals with clinical risks and require timely medical treatment based on the situation.'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'Analysis results of point mutation (SNVs) or missing duplication (CNVs) :'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: 'Gene' }]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Chrom'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Pos'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Transcript'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Exon'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Nucleotide'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: 'Amino acid'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Pure sum/hybrid' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'gAD_EAS' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'ACMG' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Disease name' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'Clinical significance' }]
            }
          ]
        },
        ...reportsVariants
          .filter(
            (item) =>
              !(
                item.gene === 'HBB' ||
                item.gene === 'HBA1' ||
                item.gene === 'HBA2'
              )
          )
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.gene
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              type: 'p3-center',
                              children: [
                                {
                                  text: `${row.chrom}:${row.pos}`
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'p3-center',
                          children: [
                            {
                              type: 'p3-center',
                              children: [
                                {
                                  text: `${row.transcript}`
                                }
                              ]
                            },
                            {
                              type: 'p3-center',
                              children: [
                                {
                                  text: `${row.var_location}${
                                    row.exon === '.' ? '' : `(${row.exon})`
                                  }`
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.c_nomen ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.p_nomen
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.allele_frequency
                            ? row.allele_frequency < 0.85
                              ? 'heterozygote'
                              : 'homozygote'
                            : 'null'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.gnomAD_exome_EAS}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? row.user_acmg_classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.ACMG_classification
                            ? row.ACMG_classification?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: row.OMIMEN ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: row.OMIM?.geneMim
                            ? `OMIM ID: ${row.OMIM?.geneMim}`
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.variantsType
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          })
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: 'Note: Prediction: Protein function prediction software REVEL: D: Harmful; LD: May be harmful; U: Uncertain; LB: Possibly benign; B: Benign. spliceAI: T: Affects splicing; F: Does not affect splicing. -: Unknown score: Bayesian framework Uncertain locus score and corresponding pathogenicity probability: <0(0.1%); 0 (10%); 1 (18.8%); 2 (32.5%); 3 (50%); 4 (67.5%); 5 (81.2%); ≥6(≥ 90%)'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: 'Clinical significance: The impact of genetic variations on the health of the examinee. "Disease risk" represents a high risk of the examinee developing related diseases. "Carrying" indicates that the risk of the examinee developing the disease is very low, but attention should be paid to the risk of the spouse carrying the variant sites and giving birth.'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'Result analysis:'
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: '1) Detailed interpretation of genetic variation information:'
        }
      ]
    },
    ...reportsVariants
      .filter(
        (item) =>
          !(item.gene === 'HBB' || item.gene === 'HBA1' || item.gene === 'HBA2')
      )
      .map((items, index) => {
        return {
          type: 'paragraph-2',
          children: [
            {
              type: 'paragraph-2',
              children: [
                {
                  text: `This sample was analyzed to ${items?.gene} gene has one heterozygous mutation: ${items?.c_nomen} Heterozygous mutation, resulting in splicing mutation of amino acids (${items?.p_nomen}). The detailed interpretation of the genetic variation information of ACMG is as follows:`
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: `(${index + 1})${items?.c_nomen} (${
                    items?.transcript
                  }, ${items?.var_location}), resulting in amino acid changes ${
                    items?.c_nomen
                  }, is a splicing mutation.`
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: 'According to the ACMG guidelines, this variation is initially determined as:'
                }
              ]
            },
            {
              type: 'span-blod-red',
              children: [
                {
                  text: `Pathogenic variation (${classify(
                    items?.acmg_evidences ?? []
                  )}) ${items?.acmg_evidences?.join('+')}`
                }
              ]
            },
            {
              type: 'p7',
              children: items.acmg_evidences
                ? items.acmg_evidences?.map((item: any) => {
                    const first = item.split('_')[0]
                    let text = ACMG_evidences_en[first]

                    const temp = userAcmgData.find(
                      (log) =>
                        log.variantKey ===
                          `${items.gene}-${items.c_nomen}-${items.transcript}` &&
                        `${first}${
                          judgeStrength(item) ? `-${judgeStrength(item)}` : ''
                        }` === log.acmgCriteria
                    )

                    if (first === 'PM2') {
                      text = `The mutation frequency in the GnomAD database is:${items.MAX_AF}`
                    }

                    return {
                      type: 'p9',
                      children: [
                        {
                          text: `${item}:${temp ? temp?.evidenceDetails : text}`
                        }
                      ]
                    }
                  })
                : [
                    {
                      type: 'display-none',
                      children: [
                        {
                          text: ``
                        }
                      ]
                    }
                  ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: `The frequency in the normal population database is ${items.gnomAD_exome_ALL}; Since no samples from parents were received, the verification of the source of genetic variations was not conducted.`
                }
              ]
            },
            {
              type: 'p9',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      }),
    {
      type: 'h5-genetic',
      children: [
        {
          text: '2) Clinical description of the disease'
        }
      ]
    },
    ...reportsVariants
      .filter(
        (item) =>
          !(item.gene === 'HBB' || item.gene === 'HBA1' || item.gene === 'HBA2')
      )
      .map((items, index) => {
        return {
          type: 'paragraph-2',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: `Gene：${items.gene}`
                }
              ]
            },
            ...items.OMIMData.map((item: any, i: number) => {
              const higlitghtStr = affected_child_clinicalInformation
                ? affected_child_clinicalInformation
                    .split('，')
                    .join(',')
                    .split(',')
                    .join('|')
                : ''
              const regex = new RegExp(`(${higlitghtStr})`, 'gi')
              const phenoClinicalCNText = `${
                item.clinicalSynopsis_en
                  ? item.clinicalSynopsis_en.join(';').replace(/\s+/g, '')
                  : 'No Results'
              }`

              const ClinicalHighlightedText = higlitghtStr
                ? phenoClinicalCNText.replace(
                    regex,

                    (match: any) => `<span style="color: red;">${match}</span>`
                  )
                : phenoClinicalCNText

              return {
                type: 'p9',
                children: [
                  {
                    type: 'span-blod',
                    children: [
                      {
                        text: `(${i + 1})${item.phenoName}（OMIM：${
                          item.phenoMim
                        }）；${item.inheritance}`
                      }
                    ]
                  },
                  {
                    type: 'paragraph-2',
                    children: [
                      {
                        type: 'span-blod',
                        children: [
                          {
                            text: 'Disease Introduction:'
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: 'paragraph-2',
                    children: [
                      {
                        text: `${
                          item?.phenoDescriptionENStr?.join('\n') ?? 'null'
                        }`
                      }
                    ]
                  },
                  {
                    type: 'paragraph-2',
                    children: [
                      {
                        type: 'span-blod',
                        children: [
                          {
                            text: 'Clinical phenotype:'
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: 'paragraph-2',
                    children: [
                      {
                        type: 'HighlightText',
                        children: [
                          {
                            text: ClinicalHighlightedText.replace(
                              /\(.*?\)/g,
                              ''
                            )
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }),
            {
              type: 'p9',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      }),
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'It is recommended that the spouse undergo genetic screening for the above-mentioned genes and receive genetic counseling.'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'Disease background:'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       Single-gene diseases are generally caused by mutations in a single gene and can lead to very serious consequences, such as intellectual disability, growth retardation, developmental malformations, multiple organ defects and premature death. Although every single-gene disease is very rare, the total prevalence of all single-gene diseases in newborn infants is as high as 10 per 1,000, accounting for approximately 20% of the infant mortality rate in total.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       Many serious single-gene diseases belong to autosomal recessive genetic disorders (AR). Heterozygous carriers themselves do not cause the disease. However, if the spouse carries a mutation in the same gene, there is a 1/4 chance that the offspring will become patients. If the spouse carries a variation in a different gene, the offspring will not suffer from the disease. It is only when both the father and the mother pass on a pair of variations on the same genes to their offspring that diseases occur. Carriers of single-gene diseases inherit only the variant genes from either their father or mother. They do not develop the disease but pass the variant on to the next generation. If both parents are carriers of the same genetic variation, there is a 25% chance that their children will develop the disease.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       X-linked recessive genetic disorders (XR/XLR) are theoretically caused by hemizygous variations. If the mother is a heterozygous carrier, the disease does not occur; if the son is a hemizygous carrier (hemi), the disease occurs. However, there are also some female hemizygous mutation carriers who may have clinical manifestations. X-linked dominant genetic disorders (XD/XLD) are usually present in carriers. Autosomal dominant genetic disorders (AD) are classified into dominant diseases caused by spontaneous mutations and dominant diseases inherited in the family line. Detect spontaneous variations that parents cannot screen for in their offspring; If there is a history of genetic diseases in the family, it is recommended to undergo diagnostic tests and screening is not recommended. It is recommended to screen couples of childbearing age or assisted reproductive populations without obvious genetic disease phenotypes or clear family histories. For genetic diseases that start in adulthood and dominant genetic diseases with clinical interferability, it is recommended to conduct genetic counseling in combination with the family history of the examinee.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       Some genes can cause two different genetic diseases, autosomal dominant and autosomal recessive. Carriers of pathogenic variations of such genes have an increased risk of developing autosomal dominant diseases. For example, the ATM gene can cause autosomal recessive ataxia telangiectasia and also lead to autosomal dominant tumor susceptibility. Attention should be paid to the risk of developing tumors such as breast cancer, ovarian cancer and pancreatic cancer in carriers.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       The hotspot of mitochondrial mutation is Maternal inheritance, which generally passes pathogenic variations on to offspring through the cytoplasm of the egg.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       It is estimated that every normal person carries 0 to 7 genetic variations that can cause major diseases. If the disease-causing mutations carried by a spouse are located on the same gene, it is very necessary to undergo genetic counseling. Since most single-gene diseases cannot be cured, conducting pre-pregnancy single-gene disease screening can provide accurate pre-pregnancy genetic assessment to determine the risk of pathogenic gene variations being passed on to the next generation.'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'Name' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'Sample Number' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'Average sequencing depth' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'Coverage of the target area' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '10X' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '20X' }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          const fastQc = row.fastQc ?? {}
          const pctData = (fastQc.barChartData ?? []) as any[]
          const x1 = pctData.find((i) => i.name === '1x')?.value
          const x10 = pctData.find((i) => i.name === '10x')?.value
          const x20 = pctData.find((i) => i.name === '20x')?.value

          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.patient?.patientName ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.id ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.avgReadDepth ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x10 ? `${x10}` : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x20 ? `${x20}` : '-'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: 'Methodology:'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: 'Gene-targeted capture sequencing'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: 'Limitations:'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '1. The detection project is aimed at the exon region of related genes.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '2.During data analysis, to ensure the accuracy of the data analysis, a small number of variations with too low sequencing quality within the target area will be filtered out. The variations in regions with high GC content, highly repetitive sequence regions, and pseudogene-related regions cannot be analyzed.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '3.This detection method mainly analyzes point mutations and small fragment deletions/insertions variations. For deletions/duplications/structural variations in a larger range, it can completely detect homozygous variations such as partial deletions and duplications of gene exons within the panel range, and the vast majority of heterozygous variations can be detected. However, due to the existence of data fluctuations in CNV detection, some heterozygous deletions and duplications (such as SMA, DMD exon deletions and duplications, large fragment heterozygous deletions related to α thalassemia -α 3.7, -α4.2, etc.) have inaccurate detection results. For α -thalassemia-related -α 3.7 and -α4.2, due to the high sequence homology, the judgment of heterozygous deletion results is affected by the stability of read distribution, and there is a 10-20% probability that the fracture points cannot be accurately determined. For the DMD gene, homozygous deletions can be accurately identified, while heterozygous deletions are affected by experimental fluctuations and have a 10-20% possibility of being missed. For suspicious samples, verification should be carried out by other methods. In addition, family samples that have not undergone NGS sequencing do not provide missing duplicate results.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '4.It is unable to distinguish the cis-trans configuration of variations on chromosomes, and cannot detect genomic structural variations such as chromosomal number abnormalities, translocations/inversions, as well as chimeric mutations in germ cells.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '5.This project only reports pathogenic mutations that have been clearly identified within the scope of the committed report. This report also cannot rule out the influence of other mutations outside the scope of the report, nor can it rule out the possibility that the next generation of the examinee may develop related diseases due to the de novo mutation.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '6.A negative result does not rule out the possibility that the person being tested carries pathogenic variations outside the testing range. The residual risk after testing represents the probability that the person being tested remains a carrier when the test result is negative, and the fertility risk represents the probability that the offspring of the person being tested will suffer from the tested disease.'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: 'Note:'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(1)    The reference genome version is GRCh37/hg19. The positional information of nucleotide alterations is based on the current version of the genome and transcript. This information may vary among different genome versions or transcripts.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(2)    hom/het/hemi: hom indicates that this mutation site is a homozygous mutation, het indicates that this mutation site is a heterozygous mutation, and hemi indicates that this mutation site is a hemizygous mutation.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: "(3)     Protein function prediction software REVEL(rare exome variant ensemble learner) : Am J Hum Genet. 2016 Oct 6; 99(4):877-885.[PMID: 27666373], D: Harmful; LD: May be harmful; U: Uncertain; LB: Possibly benign; B: Benign. spliceAI: T: Affects splicing; F: It doesn't affect editing. -: Unknown"
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(4)    Pathogenicity analysis was conducted in accordance with the variant interpretation guidelines issued by the American College of Medical Genetics and Genomics (ACMG) : pathogenic/ Pathogenic variants; likely pathogenic/ Suspected pathogenic variant uncertain/ Variations of unknown clinical significance; likely-benign/ Suspected benign variation benign/ Benign variation.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(5)    Mode of inheritance: AR represents autosomal recessive inheritance; AD represents autosomal dominant inheritance; XR represents X-chromosome recessive inheritance; XD represents dominant inheritance on the X chromosome.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(6)    The explanations for nucleotide variations in genes are based on the current understanding of the gene. As research deepens, these explanations may also change.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(7)    This test only conducts first-generation sequencing verification for variations that are highly correlated with disease risk.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(8)    Human phenotypes may be influenced by various factors such as genes and the environment, and there may be conditions such as incomplete externality and inconsistent expression. The absence of highly correlated variations with disease risk does not mean that the person being examined has no risk, and the detection of highly correlated variations with disease risk does not mean that the person being examined will definitely develop the disease.'
            }
          ]
        }
      ]
    },
    {
      type: 'divider',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span-blod-red',
          children: [
            {
              text: '*'
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: 'The relevant test results are for clinical reference only and cannot be used as the sole basis for diagnosis. Please conduct other auxiliary tests when necessary.'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span-blod-red',
          children: [
            {
              text: '*'
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: 'This report is only responsible for the samples collected this time. If you have any questions, please contact us within 15 working days.'
            }
          ]
        }
      ]
    },
    {
      type: 'span-start',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3',
          children: [
            {
              text: 'Tester:'
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: 'Reviewer:'
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `Report Time: ${
                formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
              }`
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
